import React, { useState, useCallback } from 'react';
import Box from '../box';
import Stack from '../stack';
import BasicSliderPattern from './components/basic-slider-pattern';
const defaultSupportedUnits = [];

const SliderPattern = ({
  value,
  iconGlyph,
  title = '',
  mixedLabel = '',
  startPoint = 0,
  max,
  min,
  step,
  supportedUnits = defaultSupportedUnits,
  defaultCollapsed = true,
  indeterminate = false,
  isValueEditable = true,
  items = undefined,
  popoverProps = undefined,
  valuePopoverProps = undefined,
  onClick = Function.prototype,
  onChange = Function.prototype,
  onAfterChange = Function.prototype,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  const handleClick = useCallback(() => {
    setIsCollapsed((currentIsCollapse) => {
      const newIsCollapse = !currentIsCollapse;

      onClick(newIsCollapse);
      return newIsCollapse;
    });
  }, [onClick]);

  return (
    <div className="ws-ui-slider-pattern">
      <BasicSliderPattern
        title={title}
        mixedLabel={mixedLabel}
        iconGlyph={iconGlyph}
        value={value}
        startPoint={startPoint}
        min={min}
        max={max}
        step={step}
        supportedUnits={supportedUnits}
        indeterminate={indeterminate}
        isValueEditable={isValueEditable}
        popoverProps={popoverProps}
        valuePopoverProps={valuePopoverProps}
        selected={!isCollapsed}
        {...(items && { onClick: handleClick })}
        onChange={onChange}
        onAfterChange={onAfterChange}
      />

      {items && !isCollapsed && (
        <Box marginTop="spacing-2-xs">
          <Stack gap="spacing-3-xs">
            {items.map((item, index) => (
              <BasicSliderPattern
                // eslint-disable-next-line yola/react/no-array-index-key
                key={index}
                title={title}
                mixedLabel={mixedLabel}
                iconGlyph={item.iconGlyph}
                value={item.value}
                startPoint={startPoint}
                min={min}
                max={max}
                step={step}
                supportedUnits={supportedUnits}
                indeterminate={item.indeterminate}
                isValueEditable={isValueEditable}
                popoverProps={item.popoverProps}
                valuePopoverProps={item.valuePopoverProps}
                onChange={item.onChange}
                onAfterChange={item.onAfterChange}
              />
            ))}
          </Stack>
        </Box>
      )}
    </div>
  );
};

export default SliderPattern;
